import { Entry } from 'types/entry';
import { PostCode } from 'types/post-code';
import { Price } from 'types/price';
import { OptionCollect } from 'types/return-entries';

export enum ExchangeChannel {
  store = 'STORE',
  web = 'WEB',
  webmobile = 'WEBMOBILE',
}

export type ReturnConsignment = {
  consignmentCode: string;
  customerName: string;
  optionsCollect: string;
  returnRequestStatus: string;
  customerCpf: string;
  protocol: string;
  createdDate: Date;
};

export type SummaryEntry = {
  entry: Entry;
  action: string;
  expectedQuantity: number;
  status: string;
  reason: string;
  additionalReason: string;
  additionalInformation: string;
};

export type ReturnDetails = {
  consignmentCode: string;
  entries: SummaryEntry[];
  isChargedback: boolean;
  option: OptionCollect;
  protocol: string;
  status: string;
  postOffice: PostCode;
  cancelDescription: string;
  refundedDate: Date;
  refundPrice: Price;
  exchangeChannel: ExchangeChannel;
};
